import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";

export default function POS({ products }) {
    const [cart, setCart] = useState([]);

    const addToCart = (product) => {
        setCart([...cart, product]);
    };

    const total = cart.reduce((sum, p) => sum + Number(p.price), 0);

    return (
        <div>
            <h3>Punto de Venta</h3>
            <div className="row">
                <div className="col-md-6">
                    <h5>Productos Disponibles</h5>
                    <Table bordered>
                        <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Precio</th>
                            <th>Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {products.map((p) => (
                            <tr key={p.id}>
                                <td>{p.name}</td>
                                <td>${p.price}</td>
                                <td>
                                    <Button variant="primary" size="sm" onClick={() => addToCart(p)}>
                                        Agregar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>
                <div className="col-md-6">
                    <h5>Carrito</h5>
                    <Table bordered>
                        <thead>
                        <tr>
                            <th>Producto</th>
                            <th>Precio</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cart.map((p, index) => (
                            <tr key={index}>
                                <td>{p.name}</td>
                                <td>${p.price}</td>
                            </tr>
                        ))}
                        <tr>
                            <td><strong>Total</strong></td>
                            <td><strong>${total}</strong></td>
                        </tr>
                        </tbody>
                    </Table>
                    <Button variant="success">Finalizar Venta</Button>
                </div>
            </div>
        </div>
    );
}